const texts = {
    "print-label-sent-by-email": {
        // TODO Replaced by CARRIER_DEFAULT
        EN: "An email with detailed instructions on how to return your items has been sent to you",
        DA: "En e-mail med detaljerede instruktioner om hvordan du returnerer dine varer er blevet sendt til dig",
        DE: "Eine E-Mail mit detaillierten Anweisungen zur Rücksendung Ihrer Artikel wurde an Sie gesendet",
        NL: "Een e-mail met gedetailleerde instructies over hoe je je artikelen retourneert is naar je verzonden",
        FR: "Un e-mail avec des instructions détaillées sur la façon de retourner vos articles vous a été envoyé",
        IT: "Ti è stata inviata un'e-mail con istruzioni dettagliate su come restituire i tuoi articoli",
        ES: "Se te ha enviado un correo electrónico con instrucciones detalladas sobre cómo devolver tus artículos",
        PT: "Foi enviado a você um e-mail com instruções detalhadas sobre como devolver seus itens",
        FI: "Sinulle on lähetetty sähköposti yksityiskohtaisin ohjein tuotteiden palauttamisesta",
        SV: "Ett mejl med instruktioner för hur du returnerar dina varor har skickats till dig",
        NO: "En e-post med instruksjoner for hvordan du returnerer varene dine er sendt til deg",
    },
    "print-label-sent-by-email.CARRIER_DEFAULT": {
        EN: "An email with detailed instructions on how to return your items has been sent to you",
        DA: "En e-mail med detaljerede instruktioner om hvordan du returnerer dine varer er blevet sendt til dig",
        DE: "Eine E-Mail mit detaillierten Anweisungen zur Rücksendung Ihrer Artikel wurde an Sie gesendet",
        NL: "Een e-mail met gedetailleerde instructies over hoe je je artikelen retourneert is naar je verzonden",
        FR: "Un e-mail avec des instructions détaillées sur la façon de retourner vos articles vous a été envoyé",
        IT: "Ti è stata inviata un'e-mail con istruzioni dettagliate su come restituire i tuoi articoli",
        ES: "Se te ha enviado un correo electrónico con instrucciones detalladas sobre cómo devolver tus artículos",
        PT: "Foi enviado a você um e-mail com instruções detalhadas sobre como devolver seus itens",
        FI: "Sinulle on lähetetty sähköposti yksityiskohtaisin ohjein tuotteiden palauttamisesta",
        SV: "Ett mejl med instruktioner för hur du returnerar dina varor har skickats till dig",
        NO: "En e-post med instruksjoner for hvordan du returnerer varene dine er sendt til deg",
    },
    "print-label-sent-by-email.INGRID_HELTHJEM": {
        EN: "Please write the return code <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> on your package and hand it over to a Helthjem service point.",
        DA: "Skriv venligst returkoden <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> på din pakke og aflever den til et Helthjem servicepunkt.",
        DE: "Bitte schreiben Sie den Rückgabecode <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> auf Ihr Paket und geben Sie es bei einem Helthjem-Servicepunkt ab.",
        NL: "Schrijf de retourcode <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> op je pakket en lever het in bij een Helthjem servicepunt.",
        FR: "Veuillez écrire le code de retour <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> sur votre colis et le remettre à un point de service Helthjem.",
        IT: "Scrivi il codice di reso <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> sul tuo pacco e consegnalo a un punto di servizio Helthjem.",
        ES: "Escribe el código de devolución <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> en tu paquete y entrégalo en un punto de servicio Helthjem.",
        PT: "Escreva o código de devolução <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> em seu pacote e entregue-o em um ponto de serviço Helthjem.",
        SV: "Vänligen skriv returkoden <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> på ditt paket och lämna det till ett Helthjem ombud.",
        NO: "Vennligst skriv returkoden <span style='font-family: monospace; font-weight: bold;'>${returnCode}</span> på pakken din og lever den til et Helthjem ombud.",
    },
    "no-service-point-close.CARRIER_DEFAULT.text": {
        EN: "",
    },
    "no-service-point-close.CARRIER_DEFAULT.href": {
        EN: "",
    },
    "no-service-point-close.DHL_EXPRESS.text": {
        EN: "There is no DHL Service Point close to me (book pickup):",
        DA: "Der er ingen DHL servicepunkt tæt på mig (bestil afhentning):",
        DE: "Es gibt keinen DHL-Servicepunkt in meiner Nähe (Abholung buchen):",
        NL: "Er is geen DHL-servicepunt bij mij in de buurt (ophaling boeken):",
        FR: "Il n'y a pas de point de service DHL près de chez moi (réserver un enlèvement):",
        IT: "Non c'è un punto di servizio DHL vicino a me (prenota ritiro):",
        ES: "No hay un punto de servicio DHL cerca de mí (reservar recogida):",
        PT: "Não há ponto de serviço DHL perto de mim (agendar coleta):",
    },
    "no-service-point-close.DHL_EXPRESS.href": { EN: "https://mydhl.express.dhl" },
    "find-closest-service-point.CARRIER_DEFAULT.text": {
        EN: "",
    },
    "find-closest-service-point.CARRIER_DEFAULT.href": {
        EN: "",
    },
    "find-closest-service-point.BRING.text": {
        EN: "Find your nearest Bring Service Point here:",
        DA: "Find dit nærmeste Bring servicepunkt her:",
        DE: "Finden Sie hier Ihren nächsten Bring-Servicepunkt:",
        NL: "Vind hier je dichtstbijzijnde Bring-servicepunt:",
        FR: "Trouvez votre point de service Bring le plus proche ici:",
        IT: "Trova qui il tuo punto di servizio Bring più vicino:",
        ES: "Encuentra aquí tu punto de servicio Bring más cercano:",
        PT: "Encontre aqui o ponto de serviço Bring mais próximo:",
    },
    "find-closest-service-point.BRING.href": {
        EN: "https://www.bring.se/privat/kundservice/utlamningsstallen",
        NO: "https://www.bring.no/kart",
    },
    "find-closest-service-point.DHL_EXPRESS.text": {
        EN: "Find your nearest DHL Service Point here:",
        DA: "Find dit nærmeste DHL servicepunkt her:",
        DE: "Finden Sie hier Ihren nächsten DHL-Servicepunkt:",
        NL: "Vind hier je dichtstbijzijnde DHL-servicepunt:",
        FR: "Trouvez votre point de service DHL le plus proche ici:",
        IT: "Trova qui il tuo punto di servizio DHL più vicino:",
        ES: "Encuentra aquí tu punto de servicio DHL más cercano:",
        PT: "Encontre aqui o ponto de serviço DHL mais próximo:",
    },
    "find-closest-service-point.DHL_EXPRESS.href": {
        EN: "https://locator.dhl.com",
    },
    "find-closest-service-point.DHL_FREIGHT.text": {
        EN: "Find your nearest DHL Service Point here:",
        DA: "Find dit nærmeste DHL servicepunkt her:",
        DE: "Finden Sie hier Ihren nächsten DHL-Servicepunkt:",
        NL: "Vind hier je dichtstbijzijnde DHL-servicepunt:",
        FR: "Trouvez votre point de service DHL le plus proche ici:",
        IT: "Trova qui il tuo punto di servizio DHL più vicino:",
        ES: "Encuentra aquí tu punto de servicio DHL más cercano:",
        PT: "Encontre aqui o ponto de serviço DHL mais próximo:",
    },
    "find-closest-service-point.DHL_FREIGHT.href": {
        EN: "https://locator.dhl.com",
    },
    "find-closest-service-point.DHL_PARCEL_CONNECT.text": {
        EN: "Find your nearest DHL Service Point here:",
        DA: "Find dit nærmeste DHL servicepunkt her:",
        DE: "Finden Sie hier Ihren nächsten DHL-Servicepunkt:",
        NL: "Vind hier je dichtstbijzijnde DHL-servicepunt:",
        FR: "Trouvez votre point de service DHL le plus proche ici:",
        IT: "Trova qui il tuo punto di servizio DHL più vicino:",
        ES: "Encuentra aquí tu punto de servicio DHL más cercano:",
        PT: "Encontre aqui o ponto de serviço DHL mais próximo:",
    },
    "find-closest-service-point.DHL_PARCEL_CONNECT.href": {
        EN: "https://locator.dhl.com",
    },
    "find-closest-service-point.DHL_PARCEL_GERMANY.text": {
        EN: "Find your nearest DHL Service Point here:",
        DA: "Find dit nærmeste DHL servicepunkt her:",
        DE: "Finden Sie hier Ihren nächsten DHL-Servicepunkt:",
        NL: "Vind hier je dichtstbijzijnde DHL-servicepunt:",
        FR: "Trouvez votre point de service DHL le plus proche ici:",
        IT: "Trova qui il tuo punto di servizio DHL più vicino:",
        ES: "Encuentra aquí tu punto de servicio DHL más cercano:",
        PT: "Encontre aqui o ponto de serviço DHL mais próximo:",
    },
    "find-closest-service-point.DHL_PARCEL_GERMANY.href": {
        EN: "https://locator.dhl.com",
    },
    "find-closest-service-point.UPS.text": {
        EN: "Find your nearest UPS Access Point here:",
        DA: "Find dit nærmeste UPS adgangspunkt her:",
        DE: "Finden Sie hier Ihren nächsten UPS-Zugangspunkt:",
        NL: "Vind hier je dichtstbijzijnde UPS toegangspunt:",
        FR: "Trouvez votre point d'accès UPS le plus proche ici:",
        IT: "Trova qui il tuo punto di accesso UPS più vicino:",
        ES: "Encuentra aquí tu punto de acceso UPS más cercano:",
        PT: "Encontre aqui o ponto de acesso UPS mais próximo:",
    },
    "find-closest-service-point.UPS.href": {
        EN: "https://www.ups.com/dropoff/",
    },
    "find-closest-service-point.POSTNORD.text": {
        EN: "Find your nearest Postnord Access Point here:",
        DA: "Find dit nærmeste Postnord adgangspunkt her:",
        DE: "Finden Sie hier Ihren nächsten Postnord-Zugangspunkt:",
        NL: "Vind hier je dichtstbijzijnde Postnord toegangspunt:",
        FR: "Trouvez votre point d'accès Postnord le plus proche ici:",
        IT: "Trova qui il tuo punto di accesso Postnord più vicino:",
        ES: "Encuentra aquí tu punto de acceso Postnord más cercano:",
        PT: "Encontre aqui o ponto de acesso Postnord mais próximo:",
        SV: "Hitta Serviceställe",
        NO: "Finn Servicepunkt",
    },
    "find-closest-service-point.POSTNORD.href": {
        EN: "https://www.postnord.se/en/our-tools/find-service-point",
        SV: "https://www.postnord.se/vara-verktyg/hitta-servicestalle",
        NO: "https://my.postnord.no/delivery-locations",
    },
    "qr-code-in-pdf-return-instructions.default": {
        //TODO Remove, replaced
        EN: "To return your item(s), please download the qrcode using the button and follow any included instructions.",
        DA: "For at returnere dine varer, download venligst QR-koden ved hjælp af knappen og følg eventuelle medsendte instruktioner.",
        DE: "Um Ihre Artikel zurückzusenden, laden Sie bitte den QR-Code über die Schaltfläche herunter und folgen Sie den beigefügten Anweisungen.",
        NL: "Om je artikel(en) te retourneren, download je de QR-code met de knop en volg je de bijgevoegde instructies.",
        FR: "Pour retourner vos articles, veuillez télécharger le code QR en utilisant le bouton et suivre les instructions incluses.",
        IT: "Per restituire i tuoi articoli, scarica il codice QR usando il pulsante e segui le istruzioni incluse.",
        ES: "Para devolver tus artículos, descarga el código QR usando el botón y sigue las instrucciones incluidas.",
        PT: "Para devolver seus itens, faça o download do código QR usando o botão e siga as instruções incluídas.",
    },
    "qr-code-in-pdf-return-instructions.CARRIER_DEFAULT": {
        EN: "To return your item(s), please download the qrcode using the button and follow any included instructions.",
        DA: "For at returnere dine varer, download venligst QR-koden ved hjælp af knappen og følg eventuelle medsendte instruktioner.",
        DE: "Um Ihre Artikel zurückzusenden, laden Sie bitte den QR-Code über die Schaltfläche herunter und folgen Sie den beigefügten Anweisungen.",
        NL: "Om je artikel(en) te retourneren, download je de QR-code met de knop en volg je de bijgevoegde instructies.",
        FR: "Pour retourner vos articles, veuillez télécharger le code QR en utilisant le bouton et suivre les instructions incluses.",
        IT: "Per restituire i tuoi articoli, scarica il codice QR usando il pulsante e segui le istruzioni incluse.",
        ES: "Para devolver tus artículos, descarga el código QR usando el botón y sigue las instrucciones incluidas.",
        PT: "Para devolver seus itens, faça o download do código QR usando o botão e siga as instruções incluídas.",
    },
    "qr-code-in-pdf-return-instructions.INPOST": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Place the item(s) in the original box, ensuring it is securely sealed.\n\n" +
            "2. Go to a service point and show the below QR code for the ${carrier} carrier to print the shipping documents.\n\n" +
            "Find your nearest service point here: \n l{https://inpost.co.uk/lockers}",
    },
    "qr-code-in-pdf-return-instructions.DPD": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Place the item(s) in the original box, ensuring it is securely sealed.\n\n" +
            "2. Go to a service point and show the below QR code for the ${carrier} carrier to print the shipping documents.\n\n" +
            "Find your nearest service point here: \n l{https://www.dpd.com\n}",
        NL:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Place the item(s) in the original box, ensuring it is securely sealed.\n\n" +
            "2. Go to a service point and show the below QR code for the ${carrier} carrier to print the shipping documents.\n\n" +
            "Find your nearest service point here: \n l{https://www.dpd.com/nl/nl/\n}",
    },
    "qr-code-in-pdf-return-instructions-button": {
        EN: "Download QR-code",
        DA: "Download QR-kode",
        DE: "QR-Code herunterladen",
        NL: "Download QR-code",
        FR: "Télécharger le code QR",
        IT: "Scarica codice QR",
        ES: "Descargar código QR",
        PT: "Baixar código QR",
    },
    "qr-code-return-instructions.default": {
        //TODO Remove. Replaced
        EN:
            "To return your item(s), please follow the steps below:<br/>" +
            "<br/>" +
            "1. Place the item(s) in the original box, ensuring it is securely sealed.<br/><br/>" +
            "2. Go to a service point and show the below QR code for the ${carrier} carrier to print the shipping documents.",
        DA:
            "For at returnere dine varer, følg venligst nedenstående trin:<br/>" +
            "<br/>" +
            "1. Læg varen/varerne i den originale æske og sørg for at den er forsvarligt forseglet.<br/><br/>" +
            "2. Gå til et servicepunkt og vis nedenstående QR-kode for ${carrier} transportøren for at udskrive forsendelsesdokumenterne.",
        DE:
            "Um Ihre Artikel zurückzusenden, befolgen Sie bitte die folgenden Schritte:<br/>" +
            "<br/>" +
            "1. Legen Sie die Artikel in die Originalverpackung und stellen Sie sicher, dass sie sicher verschlossen ist.<br/><br/>" +
            "2. Gehen Sie zu einem Servicepunkt und zeigen Sie den unten stehenden QR-Code für den ${carrier} Spediteur, um die Versanddokumente zu drucken.",
        NL:
            "Om je artikel(en) te retourneren, volg de onderstaande stappen:<br/>" +
            "<br/>" +
            "1. Plaats de item(s) in de originele doos en zorg ervoor dat deze goed verzegeld is.<br/><br/>" +
            "2. Ga naar een servicepunt en toon de onderstaande QR-code voor de ${carrier} vervoerder om de verzenddocumenten af te drukken.",
        FR:
            "Pour retourner vos articles, veuillez suivre les étapes ci-dessous:<br/>" +
            "<br/>" +
            "1. Placez les articles dans la boîte d'origine en vous assurant qu'elle est bien scellée.<br/><br/>" +
            "2. Rendez-vous à un point de service et montrez le code QR ci-dessous pour que le transporteur ${carrier} imprime les documents d'expédition.",
        IT:
            "Per restituire i tuoi articoli, segui i passaggi di seguito:<br/>" +
            "<br/>" +
            "1. Posiziona gli articoli nella scatola originale assicurandoti che sia ben sigillata.<br/><br/>" +
            "2. Vai a un punto di servizio e mostra il codice QR qui sotto per far stampare i documenti di spedizione al corriere ${carrier}.",
        ES:
            "Para devolver tus artículos, sigue los pasos a continuación:<br/>" +
            "<br/>" +
            "1. Coloca los artículos en la caja original asegurándote de que esté bien sellada.<br/><br/>" +
            "2. Ve a un punto de servicio y muestra el código QR de abajo para que el transportista ${carrier} imprima los documentos de envío.",
        PT:
            "Para devolver seus itens, siga as etapas abaixo:<br/>" +
            "<br/>" +
            "1. Coloque os itens na caixa original certificando-se de que esteja bem selada.<br/>\n" +
            "2. Vá a um ponto de serviço e mostre o código QR abaixo para que a transportadora ${carrier} imprima os documentos de envio.",
    },
    "qr-code-return-instructions.CARRIER_DEFAULT": {
        EN:
            "To return your item(s), please follow the steps below:<br/>" +
            "<br/>" +
            "1. Place the item(s) in the original box, ensuring it is securely sealed.<br/><br/>" +
            "2. Go to a service point and show the below QR code for the ${carrier} carrier to print the shipping documents.",
        DA:
            "For at returnere dine varer, følg venligst nedenstående trin:<br/>" +
            "<br/>" +
            "1. Læg varen/varerne i den originale æske og sørg for at den er forsvarligt forseglet.<br/><br/>" +
            "2. Gå til et servicepunkt og vis nedenstående QR-kode for ${carrier} transportøren for at udskrive forsendelsesdokumenterne.",
        DE:
            "Um Ihre Artikel zurückzusenden, befolgen Sie bitte die folgenden Schritte:<br/>" +
            "<br/>" +
            "1. Legen Sie die Artikel in die Originalverpackung und stellen Sie sicher, dass sie sicher verschlossen ist.<br/><br/>" +
            "2. Gehen Sie zu einem Servicepunkt und zeigen Sie den unten stehenden QR-Code für den ${carrier} Spediteur, um die Versanddokumente zu drucken.",
        NL:
            "Om je artikel(en) te retourneren, volg de onderstaande stappen:<br/>" +
            "<br/>" +
            "1. Plaats de item(s) in de originele doos en zorg ervoor dat deze goed verzegeld is.<br/><br/>" +
            "2. Ga naar een servicepunt en toon de onderstaande QR-code voor de ${carrier} vervoerder om de verzenddocumenten af te drukken.",
        FR:
            "Pour retourner vos articles, veuillez suivre les étapes ci-dessous:<br/>" +
            "<br/>" +
            "1. Placez les articles dans la boîte d'origine en vous assurant qu'elle est bien scellée.<br/><br/>" +
            "2. Rendez-vous à un point de service et montrez le code QR ci-dessous pour que le transporteur ${carrier} imprime les documents d'expédition.",
        IT:
            "Per restituire i tuoi articoli, segui i passaggi di seguito:<br/>" +
            "<br/>" +
            "1. Posiziona gli articoli nella scatola originale assicurandoti che sia ben sigillata.<br/><br/>" +
            "2. Vai a un punto di servizio e mostra il codice QR qui sotto per far stampare i documenti di spedizione al corriere ${carrier}.",
        ES:
            "Para devolver tus artículos, sigue los pasos a continuación:<br/>" +
            "<br/>" +
            "1. Coloca los artículos en la caja original asegurándote de que esté bien sellada.<br/><br/>" +
            "2. Ve a un punto de servicio y muestra el código QR de abajo para que el transportista ${carrier} imprima los documentos de envío.",
        PT:
            "Para devolver seus itens, siga as etapas abaixo:<br/>" +
            "<br/>" +
            "1. Coloque os itens na caixa original certificando-se de que esteja bem selada.<br/>\n" +
            "2. Vá a um ponto de serviço e mostre o código QR abaixo para que a transportadora ${carrier} imprima os documentos de envio.",
    },
    "attach-shipment-label": {
        EN: "Pack the item/items in the original package. Attach the label to the package and take it to your nearest ${carrier} Service Point. ",
        DA: "Pak varen/varerne i originalemballagen. Sæt etiketten på pakken og tag den til dit nærmeste ${carrier} servicepunkt. ",
        DE: "Verpacken Sie den/die Artikel in der Originalverpackung. Bringen Sie das Etikett auf dem Paket an und bringen Sie es zu Ihrem nächsten ${carrier} Servicepunkt. ",
        NL: "Verpak het item/de items in de originele verpakking. Bevestig het label aan het pakket en breng het naar je dichtstbijzijnde ${carrier} servicepunt. ",
        FR: "Emballez l'article/les articles dans l'emballage d'origine. Fixez l'étiquette sur le colis et apportez-le à votre point de service ${carrier} le plus proche. ",
        IT: "Imballa l'articolo/gli articoli nella confezione originale. Attacca l'etichetta al pacco e portalo al tuo punto di servizio ${carrier} più vicino. ",
        ES: "Empaca el artículo/los artículos en el paquete original. Adhiere la etiqueta al paquete y llévalo a tu punto de servicio ${carrier} más cercano. ",
        PT: "Embale o item/os itens na embalagem original. Anexe a etiqueta ao pacote e leve-o ao ponto de serviço ${carrier} mais próximo. ",
        FI: "Pakkaa tuote/tuotteet alkuperäiseen pakkaukseen. Kiinnitä tarra pakettiin ja vie se lähimpään ${carrier}-palvelupisteeseen. ",
        SV: "Packa varan/varorna i originalförpackningen. Fäst etiketten på paketet och lämna det hos ditt närmaste ${carrier}-ombud.",
        NO: "Pakk varen/varene i originalemballasjen. Fest etiketten på pakken og lever den hos ditt nærmeste ${carrier}-utleveringssted.",
    },
    "attach-label.default": {
        // TODO Replaced by CARRIER_DEFAULT
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest ${carrier} service point or contact the carrier to schedule a pickup.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste ${carrier}-ombud eller kontakta transportören för upphämtning.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste ${carrier}-utleveringssted eller kontakt transportøren for henting.",
    },
    "attach-label.CARRIER_DEFAULT": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest ${carrier} service point or contact the carrier to schedule a pickup.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste ${carrier}-ombud eller kontakta transportören för upphämtning.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste ${carrier}-utleveringssted eller kontakt transportøren for henting.",
    },
    "attach-label.UPS": {
        EN:
            "To return your item(s), please follow the steps below:\n\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Take the package to your nearest UPS Access Point.\n\n" +
            "5. Hand over your package to the UPS agent.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste UPS Access Point.\n\n" +
            "5. Lämna över paketet till UPS-personalen.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste UPS Access Point.\n\n" +
            "5. Overlever pakken til UPS-ansatt.",
    },
    "attach-label.DPD": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest ${carrier} service point or contact the carrier to schedule a pickup. Find your nearest service point here: l{https://www.dpd.com/nl/en/}",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste ${carrier}-ombud eller kontakta transportören för upphämtning. Hitta ditt närmaste ombud här: l{https://www.dpd.com/nl/en/}",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste ${carrier}-utleveringssted eller kontakt transportøren for henting. Finn nærmeste utleveringssted her: l{https://www.dpd.com/nl/en/}",
    },
    "attach-label.INPOST": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest ${carrier} service point or contact the carrier to schedule a pickup. Find your nearest service point here: l{https://inpost.co.uk/lockers}",
    },
    "hand-over-waybill": {
        EN: "At the Service Point, hand the package b{and the Waybill} to the ${carrier} agent.",
        DA: "Ved servicepunktet, aflever pakken b{og fragtbrevet} til ${carrier} medarbejderen.",
        DE: "Am Servicepunkt übergeben Sie das Paket b{und den Frachtbrief} dem ${carrier} Mitarbeiter.",
        NL: "Bij het servicepunt, geef het pakket b{en de vrachtbrief} aan de ${carrier} medewerker.",
        FR: "Au point de service, remettez le colis b{et la lettre de transport} à l'agent ${carrier}.",
        IT: "Al punto di servizio, consegna il pacco b{e la lettera di vettura} all'agente ${carrier}.",
        ES: "En el punto de servicio, entrega el paquete b{y la carta de porte} al agente de ${carrier}.",
        PT: "No ponto de serviço, entregue o pacote b{e o conhecimento de embarque} ao agente da ${carrier}.",
        FI: "Palvelupisteessä luovuta paketti b{ja rahtikirja} ${carrier}-edustajalle.",
        SV: "Lämna paketet b{och fraktsedeln} till ${carrier}-ombudet.",
        NO: "Lever pakken b{og fraktbrevet} til ${carrier}-utleveringsstedet.",
    },
    "qr-code-do-not-work": {
        EN: "The QR-code doesn't work?",
        DA: "Virker QR-koden ikke?",
        DE: "Funktioniert der QR-Code nicht?",
        NL: "Werkt de QR-code niet?",
        FR: "Le code QR ne fonctionne pas?",
        IT: "Il codice QR non funziona?",
        ES: "¿El código QR no funciona?",
        PT: "O código QR não funciona?",
        FI: "Eikö QR-koodi toimi?",
        SV: "Fungerar inte QR-koden?",
        NO: "Fungerer ikke QR-koden?",
    },
    "print-label-customs.default": {
        //TODO Remove, replaced
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest service point or contact the carrier to schedule a pickup.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste ombud eller kontakta transportören för upphämtning.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste utleveringssted eller kontakt transportøren for henting.",
    },
    "print-label-customs.CARRIER_DEFAULT": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest service point or contact the carrier to schedule a pickup.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Lämna paketet hos ditt närmaste ombud eller kontakta transportören för upphämtning.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Lever pakken til ditt nærmeste utleveringssted eller kontakt transportøren for henting.",
    },
    "print-label-customs.DHL_EXPRESS": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the invoices and return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Attach 1 of the return-invoices on the outside of the package, preferably in a transparent plastic pocket that you tape onto the package (if you don't have a plastic pocket, you can get one at your DHL Service Point).\n\n" +
            "5. Hand over your package, Waybill, and the second return-invoice to the DHL agent.",
        SV:
            "För att returnera dina varor, följ stegen nedan:\n\n" +
            "1. Ladda ner och skriv ut tullfakturan och returetiketten.\n\n" +
            "2. Packa varan/varorna i originalförpackningen och se till att paketet är ordentligt förseglat.\n\n" +
            "3. Fäst returetiketten över den ursprungliga fraktetiketten så att inga andra etiketter eller streckkoder syns.\n\n" +
            "4. Fäst en av tullfakturorna på utsidan av paketet, helst i en genomskinlig plastficka (du kan få en hos DHL-ombudet om du inte har en hemma).\n\n" +
            "5. Lämna paketet, fraktsedeln och den andra tullfakturan till DHL-ombudet.",
        NO:
            "For å returnere varene dine, følg trinnene nedenfor:\n\n" +
            "1. Last ned og skriv ut tolldokumentene og returetiketten.\n\n" +
            "2. Pakk varen/varene i originalemballasjen og sørg for at pakken er godt forseglet.\n\n" +
            "3. Fest returetiketten over den opprinnelige fraktetiketten slik at ingen andre etiketter eller strekkoder er synlige.\n\n" +
            "4. Fest ett av tolldokumentene på utsiden av pakken, helst i en gjennomsiktig plastlomme (du kan få en hos DHL hvis du ikke har en hjemme).\n\n" +
            "5. Lever pakken, fraktbrevet og den andre tolldokumentet til DHL-ansatt.",
    },
    "print-label-customs.UPS": {
        EN:
            "To return your item(s), please follow the steps below:\n\n" +
            "1. Download and print the invoices and return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Attach 1 of the return-invoices on the outside of the package, preferably in a transparent plastic pocket that you tape onto the package.\n\n" +
            "5. Take the package to your nearest UPS Access Point.\n\n" +
            "6. Hand over your package and the remaining 2 invoices to the UPS agent.",
    },
    "print-label-customs.DPD": {
        EN:
            "To return your item(s), please follow the steps below:\n" +
            "\n" +
            "1. Download and print the return label.\n\n" +
            "2. Place the item(s) in the original box, ensuring the parcel is securely sealed.\n\n" +
            "3. Attach the return label over the original shipping label, making sure no other labels, addresses, or barcodes are visible.\n\n" +
            "4. Drop off the package at your nearest service point or contact the carrier to schedule a pickup. Find your nearest DPD Access Point here: https://www.dpd.com/nl/en/",
    },
    "print-label-no-customs-with-barcode-title": {
        EN: "Or you can simply show this barcode to you nearest ${carrier} service point",
        DA: "Eller du kan simpelthen vise denne stregkode til dit nærmeste ${carrier} servicepunkt",
        DE: "Oder Sie können diesen Barcode einfach Ihrem nächsten ${carrier} Servicepunkt zeigen",
        NL: "Of je kunt deze barcode gewoon tonen aan je dichtstbijzijnde ${carrier} servicepunt",
        FR: "Ou vous pouvez simplement montrer ce code-barres à votre point de service ${carrier} le plus proche",
        IT: "Oppure puoi semplicemente mostrare questo codice a barre al tuo punto di servizio ${carrier} più vicino",
        ES: "O simplemente puedes mostrar este código de barras a tu punto de servicio ${carrier} más cercano",
        PT: "Ou você pode simplesmente mostrar este código de barras ao seu ponto de serviço ${carrier} mais próximo",
    },
    "print-pack-and-send-shop-post-message": {
        EN: "", // Empty by default. Only fill through overrides
    },
    "print-label-event-no-customs-with-qr-post-message": {
        // TODO Remove
        EN: "", // Empty by default. Only fill through overrides
    },
    "print-label-event-no-customs-with-qr-post-message.CARRIER_DEFAULT": {
        EN: "", // Empty by default. Only fill through overrides
    },
    "print-label-event-no-customs-with-qr-post-message-POSTNORD": {
        // TODO Remove
        EN: "", // Empty by default. Only fill through overrides. Replace POSTNORD with any carrier name
    },
    "print-label-event-no-customs-with-qr-post-message.POSTNORD": {
        EN: "", // Empty by default. Only fill through overrides. Replace POSTNORD with any carrier name
    },
};
export default texts;
